import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_SUPPORTTYPES_INIT_ACTION,
  FETCH_SUPPORTTYPES_SUCCESS_ACTION,
  FETCH_SUPPORTTYPES_FAIL_ACTION,
  POST_SUPPORTQUERY_INIT_ACTION,
  POST_SUPPORTQUERY_SUCCESS_ACTION,
  POST_SUPPORTQUERY_FAIL_ACTION,
  GET_TICKETS_INIT_ACTION,
  GET_TICKETS_SUCCESS_ACTION,
  GET_TICKETS_FAIL_ACTION
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

function* getSupportTypes() {
  const token = localStorage.getItem("token");
  //let pageno = value.value === undefined ? 1 : value.value;

  try {
    const res = yield fetch(
      `${appConfig.ip}/supportType`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTTYPES_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTTYPES_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* sendSupportQuery(val) {
    const token = localStorage.getItem("token");
    const userId = JSON.parse(localStorage.getItem("userDetails")).id;
    const orgId = JSON.parse(localStorage.getItem("userDetails")).orgId;
  
    try {
        const data={userId:userId,orgId:orgId,sprtType:val.value.sptType,issueDesc:val.value.issueDesc};
        // console.log(data);
        const res = yield fetch(`${appConfig.ip}/support`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {}
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();
        // console.log(resJSON);
  
        yield put({
          type: POST_SUPPORTQUERY_SUCCESS_ACTION,
          payload: resJSON,
        });
        yield put({type: GET_TICKETS_INIT_ACTION});

        yield toast.success(`Support ticket raised!Your Ticket Number is ${resJSON.ticketNo}`, {
            autoClose: 5000,
            transition:Flip
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: POST_SUPPORTQUERY_FAIL_ACTION, error: err });
      } else {
      }
      yield toast.error("Technical Issue, your query not submitted!", {
        autoClose: 3000,
        transition:Flip
       // position: "top-center",
      });
    }
  }

  function* getSupportTickets(val) {
    // console.log(val);
    const token = localStorage.getItem("token");
    // console.log(token);
    const distID = JSON.parse(localStorage.getItem("userDetails")).id;

    let pageno = (!(val.value)) ? 1 : (val.value.page === undefined ? 1 : val.value.page);
    let filter = (!(val.value)) ? "" : (val.value.filter==="" ? "" : val.value.filter);
    
  
    try {
      const res = yield fetch(
        `${appConfig.ip}/support?userId=${distID}&sprtType=${filter}&limit=10&page=${pageno}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {}
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type: GET_TICKETS_SUCCESS_ACTION,
          payload: resJSON,
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: GET_TICKETS_FAIL_ACTION, error: err });
      } else {
      }
    }
  }


export function* SupportActionWatcher() {
  yield takeEvery(FETCH_SUPPORTTYPES_INIT_ACTION, getSupportTypes);
  yield takeEvery(POST_SUPPORTQUERY_INIT_ACTION, sendSupportQuery);
  yield takeEvery(GET_TICKETS_INIT_ACTION, getSupportTickets);
}